import * as React from "react";
import { Box, Button, Flex, InfoCircleIcon, Layout, Text } from "@draftkings/arena-web";
import { SportsbookContext } from "../../../contexts";
export const ProfitBoost = React.memo(function ProfitBoost(props) {
    const { label, status, messages, purchaseId, testId, openBoostDetails, openPromosPage } = props;
    const { dictionary } = React.useContext(SportsbookContext);
    return React.createElement(Layout, { variant: "bonus" },
        React.createElement(Flex, { gap: "8px", alignItems: "center" },
            React.createElement(Button, { testId: testId, variant: `betBoost:${status}`, onClick: openBoostDetails },
                React.createElement(Flex, { gap: '5px', alignItems: 'center' },
                    React.createElement(Box, { height: "11px" }, label),
                    React.createElement(InfoCircleIcon, { maxWidth: '16px', maxHeight: '16px', accessibilityText: dictionary.myBetsDictionary.InfoCircleIcon })))),
        messages.map((message, index) => React.createElement(Text, { key: `${purchaseId}-${index}`, testId: `message-${purchaseId}-${index}`, variant: `boostMessage${message.type}` },
            message.text,
            ".",
            message.type === "BonusDowngraded"
                && React.createElement(Button, { testId: `open-promos-page-${purchaseId}`, variant: "learnMore", onClick: openPromosPage }, dictionary.myBetsDictionary.LearnMore))));
});
//# sourceMappingURL=ProfitBoost.js.map